/*
 * @Subscription:
 * @Author: Luke Z
 * @Date: 2021-06-10 12:26:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-28 14:01:17
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading/index.tsx
 */
import React from 'react';
import { Select } from 'src/components/Antd';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { getCustomerInfoFields } from 'src/request/common';
import {
  //getContentButtonThemes,
  getContentContentPages,
  getContentLayerMetaInfo,
  getContentPagesForSisterSc,
} from 'src/request/salesChannel/content';
import { getTCs } from 'src/request/salesChannel/legal';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
//import { getContentLayerMetaInfo } from 'src/request/salesChannel/content';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';

const ContentModuleGroupPreloading = (props) => {
  const { value, onChange } = props;
  const {
    options, // exemptUuid
  } = React.useContext(ContentModuleGroupPreloadingContext);
  const { inUsePages, previousPages, pendingPages } = options;
  const disabledOptions = [...previousPages, ...pendingPages].find(
    (i) => i.uuid === value,
  );
  const _options = [];
  if (disabledOptions) {
    _options.push(disabledOptions);
  }
  _options.push(...inUsePages);

  return (
    <Select
      value={value}
      onChange={onChange}
      optionsList={_options.map((i) => {
        const { name, uuid } = i;
        return { label: name, value: uuid };
      })}
    />
  );
};

const ContentModuleGroupPreloadingContext = React.createContext({
  options: {
    inUsePages: [],
    previousPages: [],
    pendingPages: [],
  },
  tc: [],
  fields: [],
  buttons: [],
  animations: [],
  hoverAnimations: [],
  scContentPages: {},
});
const ContentModuleGroupPreloadingWrapper = (props) => {
  const { contentUuid, exemptUuid, children, saleChannelUuid } = props;
  const salesChannels = useSelector(getSalesChannels());

  const [tc, setTC] = React.useState([]);

  const currentLanguage = useQueryLanguageListContentEditor();

  const { data, loading } = useRequest(() => {
    const contentPages = getContentContentPages(contentUuid, {});
    const customerFields = getCustomerInfoFields(saleChannelUuid);
    const contentMetaInfo = getContentLayerMetaInfo(contentUuid);
    const sisterScContentPages = getContentPagesForSisterSc(
      {
        salesChannelContentUuid: contentUuid,
        salesChannelUuid: saleChannelUuid,
      },
      { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
    );
    const req = Promise.all([
      //termsAndConditions, // contentPages,
      customerFields,
      contentPages,
      contentMetaInfo,
      sisterScContentPages,
    ]);
    return req;
  });

  const _customerFields: any = get(data, '0') || [];

  const _contentPages = get(data, '1');
  const _contentMetaInfo = get(data, '2') || {};
  const _scContentPages = get(data, '3') || {};
  const scContentPages = Object.values(_scContentPages || {}).reduce(
    (pre: any, now) => {
      const salesChannelUuid = get(now, 'salesChannelUuid');
      const contentPages = (get(now, 'contentPages') || []).filter(
        (i) => i.status === 'InUse',
      );
      if (salesChannelUuid) {
        const salesChannel = salesChannels.find(
          (i) => i.uuid === salesChannelUuid,
        );
        return { ...pre, [salesChannelUuid]: { contentPages, salesChannel } };
      } else {
        return pre;
      }
    },
    {},
  );

  const buttonThemes = get(_contentMetaInfo, 'buttonThemes') || [];
  const entranceAnimations = get(_contentMetaInfo, 'entranceAnimations') || [];
  const hoverAnimations = get(_contentMetaInfo, 'hoverAnimations') || [];
  const inUsePages = get(_contentPages, 'inUsePages') || [];
  const previousPages = get(_contentPages, 'previousPages') || [];
  const pendingPages = get(_contentPages, 'pendingPages') || [];
  const options = {
    inUsePages: inUsePages.filter((i) => i.uuid !== exemptUuid),
    previousPages: previousPages.filter((i) => i.uuid !== exemptUuid),
    pendingPages: pendingPages.filter((i) => i.uuid !== exemptUuid),
  };

  React.useEffect(() => {
    getTCs(saleChannelUuid, {
      [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    }).then((res: any) => {
      const termsAndConditions = res.summaryList || [];
      setTC(termsAndConditions);
    });
  }, [currentLanguage]);

  //console.log('animations,buttons', animations, buttons);
  return (
    <ContentModuleGroupPreloadingContext.Provider
      value={{
        options: options,
        tc: tc,
        fields: _customerFields,
        buttons: buttonThemes,
        animations: entranceAnimations,
        hoverAnimations: hoverAnimations,
        scContentPages,
      }}>
      {!loading && children}
    </ContentModuleGroupPreloadingContext.Provider>
  );
};
export {
  ContentModuleGroupPreloading,
  ContentModuleGroupPreloadingContext,
  ContentModuleGroupPreloadingWrapper,
};
